import { useContext, useEffect } from "react";
import context from "../store/context";

import TendersList from "../pages/Tender/TendersList";
import NoSavedTenders from "../components/cards/NoSavedTenders";

const SavedTelegram = () => {
  const { setTelegramApiPath, setApiPath, setSearchParams } =
    useContext(context);

  useEffect(() => {
    setTelegramApiPath("");
    setApiPath("client/saved-tender");
    setSearchParams({
      title: "",
      categoryId: "",
      regionId: "",
      languageId: "",
      startDate: "",
      endDate: "",
      status: "",
      page: "",
      companyId: "",
      tenderSrc: "",
    });
    window.Telegram?.WebApp?.BackButton?.hide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TendersList
      noTendersPlaceholder={
        <NoSavedTenders tendersPath="/latest-tenders/telegram" />
      }
      categorySlider={false}
      showSearchSidebar={false}
      filter="saved"
    />
  );
};

export default SavedTelegram;
